<template>
  <div class="row">
    <div class="col-12 col-xl-5 order-1 order-xl-0">
      <b-card no-body class="shadow border overflow-hidden mt-3 mt-xl-0">
        <b-card-header :header-class="'text-center text-md-left rounded-top'">
          {{ $t('Logo') }}
        </b-card-header>
        <b-card-body class="p-3 rounded-bottom">
          <h2 class="h4">
            {{ $t('Your current logo') }}
          </h2>
          <img :src="logoUrl" class="img-fluid image w-100" alt="Work Image">
        </b-card-body>
      </b-card>
    </div>
    <div class="col-12 col-xl-7 order-0 order-xl-1">
      <b-card no-body class="shadow border overflow-hidden">
        <b-card-header :header-class="'text-center text-md-left rounded-top'">
          {{ $t('Add New') }}
        </b-card-header>
        <b-card-body class="p-3 rounded-bottom">
          <b-form-group>
            <custom-file-upload :single="true" :type="'logo'" :max-size="maxSize" @state="passState" />
          </b-form-group>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import CustomFileUpload from "@/components/form/CustomFileUpload";
const IMAGE_CACHE_BASE = process.env.VUE_APP_IMAGE_CACHE_URL;
const LOGO_FILTER = 'company_profile_thumbnail_large/';

export default {
  name: "ListingLogo",
  components: {CustomFileUpload},
  props: ['value'],
  data: function() {
    return {
      disableSave:false,
      busy: false,
      listing: this.value,
    }
  },
  computed: {
    logoUrl: function() {
      return (this.value.image)
        ? IMAGE_CACHE_BASE + LOGO_FILTER + this.value.image
        : require('@/assets/images/image-placeholder.png');
    },
    maxSize: function() {
      return this.$store.state.MAX_UPLOAD_SIZE;
    }
  },
  methods: {
    passState: function(state) {
      this.$emit('state', state);
    }
  },
  watch: {
    listing: {
      handler: function(value) {
        this.$emit('input', value);
      },
      deep: true,
    },
    value: function(value) {
      this.listing = value;
    },
  },
}
</script>

<style scoped lang="scss">
.image-wrapper {
  .image {
    max-width: 150px;
  }
}
</style>
